<template>

  <HeaderSection />

  <section id="formulario" class="bg-white py-12 font-custom-light min-h-screen">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-black" >

      <div class="container mx-auto px-4 max-w-7xl">


        <h1 class="font-normal text-custom mb-4 text-lg text-left pb-1" >
          Para participar de la cena informal previa al evento registrá abajo tu participación y reserva tu lugar en :<br><br>
          &bullet; Parrilla - Patio de la Cañada, Av. Figueroa Alcorta 360. - Lunes 17/03 a las 21.30 hs.
          <br><span class="font-extrabold italic text-sm" >*Los costos corren por cuenta de cada comensal.</span>

        </h1>

        <!-- Formulario -->
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3 ">
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Nombre" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" readonly="true"  />
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Apellido" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" readonly="true"/>
            </Field>
          </div>          
        </div>
        
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3 ">
          <div class="w-full px-2 md:w-1/1">
            <label class="block mb-1">¿Vas a asistir al pre-evento?</label>
            <Field name="opcion" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.opcion">
                <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione una opción" class="input-base" :options="opciones" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="opcion" /></span>
            </Field>
          </div>
        </div>
        <div class="flex flex-wrap py-2 gap-3 justify-center">
          <button type="submit" class="mt-8 px-4 py-2 bg-transparent border border-black hover:bg-black text-black font-semibold hover:text-white rounded" :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>CONFIRMAR
          </button>
        </div>

       
        <!--
        <div class="text-lg  pt-6">&bull; Si ya estas acreditado y no te llego el correo podes descargar tu credencial con el DNI haciendo <a class="font-semibold" href="/nplay/credencial">click aquí</a></div>
        -->
      </div>

      <BlockUI :blocked="isSubmitting" fullScreen />

    </Form>

  </section>
</template>

<script lang="ts">
import * as yup from 'yup';
import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import { useRoute } from 'vue-router'
import jsonOpciones from '@/data/preevento.json';

import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import BlockUI from 'primevue/blockui';
import HeaderSection from '@/components/HeaderSection.vue'


import suiteService, { Acreditado, StringIdLabelEntity} from 'qreventos-suite/services';
import {  UPDATE } from "qreventos-suite/constantes";
import suiteConfig from '@/services/suite.config';


interface Opcion extends StringIdLabelEntity {}


export default defineComponent({
  components: {
    HeaderSection,
    InputText, Dropdown,
    Field, ErrorMessage, Form, BlockUI
  },
  data() {
    return {
      opciones: jsonOpciones as Opcion[],
      isSubmitting: false,
      acreditadoExistente: undefined as unknown as Acreditado,
      formData: {
        nombre: '',
        apellido: '',
        opcion: undefined as unknown as Opcion,
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        opcion: yup.mixed().required('Seleccione si va a asistir'),
      });
    }
  },
  methods: {
    cancelarAcreditacion() {
      this.$router.go(0);
    },
    async onSubmit() {
      this.isSubmitting = true;

      try {
          this.acreditadoExistente.modificado = UPDATE;
          this.acreditadoExistente.dato17 = this.formData.opcion?.id;

        await suiteService.saveOrUpdate(suiteConfig.evento, this.acreditadoExistente);

        this.isSubmitting = false;
        Swal.fire({
          title: "¡Ya estás confirmado!",
          html: "Lo esperamos a las 21:30 hs. a compartir la previa en  el Patio de la Cañada. Av. Figueroa Alcorta 360",
          icon: "success",
        }).then(() => {
          window.location.href = "https://www.nplay.convergencia.com";
        });
        

      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      }
    },
  },
  async mounted() {
    const route = useRoute();
    const hash = route.params.hash as string;

    this.acreditadoExistente = await suiteService.findAcreditadoByHash(suiteConfig.evento, hash);

    console.log(this.acreditadoExistente);
    if(!this.acreditadoExistente) {
      Swal.fire({ title: "¡Atención!", html: "El acreditado no existe.", icon: "error" }).then(() => {
        window.location.href = "https://www.nplay.convergencia.com";
        return;
      });
      return;
    }

    this.formData.nombre = this.acreditadoExistente.nombre;
    this.formData.apellido = this.acreditadoExistente.apellido;

  }
});
</script>